<div class="content" *ngIf="employee$ | async as employee">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Employee Attendance: {{ employee?.firstName }} {{ employee?.lastName }}</h2>

      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <!-- <li class="breadcrumb-item">
              Dashboard
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">Employee Attendance</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap d-none">
      <div class="me-2 mb-2">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="input-icon w-120 position-relative mb-2">
        <span class="input-icon-addon">
          <i class="ti ti-calendar text-gray-9"></i>
        </span>
        <input type="text" class="form-control datetimepicker" value="15 Apr 2025" />
      </div>
      <div class="ms-2 head-icons">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="row">
    <div class="col-xl-4 d-flex">
      <div class="card flex-fill border-primary attendance-bg">
        <div class="card-body">
          <div class="mb-4 text-center">
            <h6 class="fw-medium text-gray-5 mb-1">Attendance</h6>
          </div>
          <div
            class="attendance-circle-progress attendance-progress mx-auto mb-3"
            [attr.data-value]="attendancePercent"
          >
            <span class="progress-left">
              <span class="progress-bar border-success" [style.transform]="leftRotation"></span>
            </span>
            <span class="progress-right">
              <span class="progress-bar border-success" [style.transform]="rightRotation"> </span>
            </span>
            <div class="total-work-hours text-center w-100">
              <span class="fs-13 d-block mb-1">Total Hours</span>
              <h6>{{ totalWorkHoursIncludingCurrent$ | async }}</h6>
            </div>
          </div>
          <div class="text-center">
            <ng-container *ngIf="!isPunchedIn; else punchedIn">
              <!-- Show Punch In button if not punched in -->
              <span *ngIf="latestPunchIn$ | async as latestPunchIn">
                <h6 class="fw-medium d-flex align-items-center justify-content-center mb-4">
                  <i class="ti ti-fingerprint text-primary me-1"></i>
                  <ng-container *ngIf="latestPunchIn.clockOut; else showClockIn">
                    Last Clock Out at
                    {{ latestPunchIn.clockOut | date: 'EEE, MMM dd, yyyy, hh:mm a' }}
                  </ng-container>
                  <ng-template #showClockIn>
                    Clock In at
                    {{ latestPunchIn.clockIn | date: 'EEE, MMM dd, yyyy, hh:mm a' }}
                  </ng-template>
                </h6>
              </span>
              <button
                type="button"
                class="btn btn-primary punch-btn w-100"
                (click)="punchIn()"
                *ngIf="user && employeeId && employeeId === user.id"
              >
                Clock In
              </button>
            </ng-container>

            <ng-template #punchedIn>
              <!-- Show Punch Out button if punched in -->
              <span *ngIf="latestPunchIn$ | async as latestPunchIn">
                <h6 class="fw-medium d-flex align-items-center justify-content-center mb-4">
                  <i class="ti ti-fingerprint text-primary me-1"></i>
                  Clock In at {{ latestPunchIn.clockIn | date: 'EEE, MMM dd, yyyy, hh:mm a' }}
                </h6>
              </span>
              <button
                type="button"
                class="btn btn-primary punch-btn w-100"
                (click)="punchOut()"
                *ngIf="user && employeeId && employeeId === user.id"
              >
                Clock Out
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-8 d-flex">
      <div class="row flex-fill">
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <!-- <div class="border-bottom mb-3 pb-2"> -->
              <div class="pb-2">
                <span class="avatar avatar-sm bg-primary mb-2"
                  ><i class="ti ti-clock-stop"></i
                ></span>
                <h2 class="mb-2">
                  {{ totalWithBreakToday$ | async }} /
                  <span class="fs-20 text-gray-5">{{ expectedWorkHoursToday$ | async }}</span>
                </h2>
                <p class="fw-medium text-truncate">Total Hours Today</p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13">
                  <span class="avatar avatar-xs rounded-circle bg-success flex-shrink-0 me-2">
                    <i class="ti ti-arrow-up fs-12"></i>
                  </span>
                  <span>5% This Week</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <!-- <div class="border-bottom mb-3 pb-2"> -->
              <div class="pb-2">
                <span class="avatar avatar-sm bg-dark mb-2"><i class="ti ti-clock-up"></i></span>
                <h2 class="mb-2">
                  {{ liveWeek$ | async }} /
                  <span class="fs-20 text-gray-5">{{ expectedWorkHoursThisWeek$ | async }}</span>
                </h2>
                <p class="fw-medium text-truncate">Total Hours This Week</p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13">
                  <span class="avatar avatar-xs rounded-circle bg-success flex-shrink-0 me-2">
                    <i class="ti ti-arrow-up fs-12"></i>
                  </span>
                  <span>7% Last Week</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <!-- <div class="border-bottom mb-3 pb-2"> -->
              <div class="pb-2">
                <span class="avatar avatar-sm bg-info mb-2"><i class="ti ti-calendar-up"></i></span>
                <h2 class="mb-2">
                  {{ liveMonth$ | async }} /
                  <span class="fs-20 text-gray-5">{{ expectedWorkHoursThisMonth$ | async }}</span>
                </h2>
                <p class="fw-medium text-truncate">Total Hours This Month</p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13 text-truncate">
                  <span class="avatar avatar-xs rounded-circle bg-danger flex-shrink-0 me-2">
                    <i class="ti ti-arrow-down fs-12"></i>
                  </span>
                  <span>8% Last Month</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="pb-2">
                <span class="avatar avatar-sm bg-pink mb-2"
                  ><i class="ti ti-calendar-star"></i
                ></span>
                <!-- <h2 class="mb-2">16 / <span class="fs-20 text-gray-5"> 28</span></h2> -->
                <h2 class="mb-2">{{ totalOvertimeThisMonth$ | async }}</h2>
                <p class="fw-medium text-truncate">Overtime This Month</p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13 text-truncate">
                  <span class="avatar avatar-xs rounded-circle bg-danger flex-shrink-0 me-2">
                    <i class="ti ti-arrow-down fs-12"></i>
                  </span>
                  <span>6% Last Month</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-dark-transparent me-1"></i>Total Working
                      Hour
                    </p>
                    <h3>{{ totalWithBreakToday$ | async }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-success me-1"></i>Productive Hours
                    </p>
                    <h3>{{ liveToday$ | async }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-warning me-1"></i>Break Hours
                    </p>
                    <h3>{{ totalBreakHoursToday$ | async }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-info me-1"></i>Overtime
                    </p>
                    <!-- <h3>02h 15m</h3> -->
                    <h3>{{ totalOvertimeToday$ | async }}</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="progress bg-transparent-dark mb-3" style="height: 24px">
                    <ng-container *ngFor="let progress of progressData">
                      <div
                        class="progress-bar rounded"
                        [ngClass]="progress.color"
                        role="progressbar"
                        [style.width]="progress.width"
                      ></div>
                    </ng-container>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
                  >
                    <ng-container *ngFor="let hour of timeLabels">
                      <span class="fs-10">{{ hour }}</span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Employee Attendance</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
          <select
            data-extension-safe
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>
        <div class="me-3">
          <div class="input-icon position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <input
              type="text"
              id="employeeAttendanceDateRange"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              style="min-width: 210px"
              readonly
            />
          </div>
        </div>
        <div class="dropdown me-3">
          <select class="form-select" [(ngModel)]="status" (change)="onStatusChange()">
            <option value="" selected>All Status</option>
            <option value="Present">Present</option>
            <option value="Absent">Absent</option>
            <option value="Leave">Leave</option>
            <option value="Late">Late Login</option>
            <option value="Early">Early</option>
            <option value="Holiday">Holiday</option>
            <option value="Weekly Off">Weekly Off</option>
            <!-- <option value="Uninformed">Uninformed</option> -->
          </select>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="attendances$ | async as employeeClockInOut; else noRecords">
          <table class="table datatable" *ngIf="employeeClockInOut.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <th>Date</th>
                <!-- <th>Clock In</th> -->
                <th>Status</th>
                <!-- <th>Clock Out</th> -->
                <th>Break</th>
                <th>Late</th>
                <th>Overtime</th>
                <th>Productive Hours</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let attendance of attendances$ | async">
                <td>
                  <a
                    href="javascript:void(0)"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightAttendancePolicy"
                    aria-controls="offcanvasRightAttendancePolicy"
                    (click)="openOffcanvasAttendance(attendance)"
                  >
                    {{ attendance.date | date: 'mediumDate' }}</a
                  >
                </td>
                <!-- <td>{{ attendance.firstClockIn | date: 'hh:mm a' }}</td> -->
                <!-- <td>
                  {{
                    attendance.workStatus === 'Leave'
                      ? '--'
                      : (attendance.firstClockIn | date: 'hh:mm a')
                  }}
                </td> -->
                <!-- <td>
                  {{
                    attendance.workStatus?.length === 1 && attendance.workStatus.includes('Leave')
                      ? '--'
                      : attendance.recordByStatus?.['Clock In/Out']?.firstClockIn
                        ? (attendance.recordByStatus?.['Clock In/Out'].firstClockIn | date: 'hh:mm a')
                        : '--'
                  }}
                </td> -->
                <!-- <td>
                  {{
                    attendance.workStatus?.length === 1 && attendance.workStatus.includes('Leave')
                      ? '--'
                      : attendance.firstClockIn
                        ? (attendance.firstClockIn | date: 'hh:mm a')
                        : '--'
                  }}
                </td> -->

                <!-- Clock In -->
                <!-- <td>
                  {{
                    attendance.recordByStatus?.['Present']?.clockIn
                      ? (attendance.recordByStatus?.['Present']?.clockIn | date: 'hh:mm a')
                      : '--'
                  }}
                </td> -->

                <!-- <td> -->
                <!-- Show this when NOT late -->
                <!-- <span
                    *ngIf="attendance.workStatus !== 'Late'"
                    class="badge badge-success-transparent d-inline-flex align-items-center"
                  >
                   
                    {{ attendance.workStatus }}
                  </span> -->

                <!-- Show this ONLY when Late -->
                <!-- <span *ngIf="attendance.workStatus === 'Late'" class="badge badge-danger ms-1">
                   
                    {{ attendance.workStatus }}
                  </span> -->
                <!-- </td> -->
                <td>
                  <ng-container *ngFor="let status of attendance.workStatus">
                    <span
                      class="badge d-inline-flex align-items-center me-2"
                      [ngStyle]="{
                        'background-color': getStatusColor(status),
                        color:
                          getStatusColor(status) === '#FF5252' ||
                          getStatusColor(status) === '#4ECDC4' ||
                          getStatusColor(status) === '#B39DDB'
                            ? '#fff'
                            : '#000'
                      }"
                    >
                      <!-- -->
                      <!-- {{ attendance.workStatus }} -->
                      {{ status }}
                    </span>
                  </ng-container>
                </td>
                <!-- <td>
                  {{ attendance.lastClockOut ? (attendance.lastClockOut | date: 'hh:mm a') : '--' }}
                </td> -->
                <!-- <td>
                  {{ isPunchedIn ? '--' : (attendance.lastClockOut | date: 'hh:mm a') }}
                </td> -->
                <!-- <td>
                  {{
                    attendance.workStatus === 'Leave'
                      ? '--'
                      : attendance.lastClockOut
                        ? (attendance.lastClockOut | date: 'hh:mm a')
                        : '--'
                  }}
                </td> -->

                <!-- Clock Out -->
                <!-- <td>
                  {{
                    attendance.recordByStatus?.['Present']?.clockOut
                      ? (attendance.recordByStatus?.['Present']?.clockOut | date: 'hh:mm a')
                      : '--'
                  }}
                </td> -->

                <td>{{ attendance.totalBreakHours }}</td>
                <td>{{ attendance.lateLogin || '0h 0m' }}</td>
                <!-- <td>20 Min</td> -->
                <td>{{ attendance.overTime || '0h 0m' }}</td>
                <td>
                  <!-- <span class="badge badge-success d-inline-flex align-items-center">
                    <i class="ti ti-clock-hour-11 me-1"></i>{{ attendance.totalWorkHours }}
                  </span> -->
                  <span class="badge badge-success d-inline-flex align-items-center">
                    <i class="ti ti-clock-hour-11 me-1"></i>
                    <!-- {{ liveToday$ | async }} -->
                    {{ attendance.productiveHours || '0h 0m' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>

    <!-- pagination -->
    <div
      *ngIf="((attendances$ | async)?.length ?? 0) > 0"
      class="d-flex align-items-center justify-content-between ms-2"
    >
      <div>
        <!-- Showing
        {{ totalCount === 0 ? 0 : (currentPage - 1) * pageLimit + 1 }}
        to
        {{ totalCount === 0 ? 0 : pageLastRecord }}
        of
        {{ totalCount }} -->
        Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ currentPage * pageLimit }} of
        {{ totalCount }} entries
      </div>
      <div class="has-text-centered mt-3">
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageLimit"
          [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"
        ></app-pagination>
      </div>
    </div>
  </div>

  <!-- attendance policy offcanvas -->
  <!-- <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRightAttendancePolicy"
    aria-labelledby="offcanvasRightLabel"
    *ngIf="selectedAttendance"
  > -->
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRightAttendancePolicy"
    aria-labelledby="offcanvasRightLabel"
    [hidden]="!selectedAttendance"
  >
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel">
        Attendance Details - {{ selectedAttendance.date | date: 'mediumDate' }}
      </h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <!-- end offcanvas-header-->

    <div class="offcanvas-body">
      <div class="flex-fill">
        <div class="card-header">
          <!-- <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
          <h5>Attendance Details </h5>
        </div> -->
          <div class="c schedule-timeline">
            <div
              class="d-flex align-items-start"
              *ngFor="let attendanceclockin of selectedAttendance?.dayRecords?.slice()?.reverse()"
            >
              <div class="d-flex align-items-center active-time">
                <span>{{ attendanceclockin.clockIn | date: 'h:mm a' }}</span>
                <span>
                  <!-- <i
                    class="ti ti-point-filled fs-20"
                    [ngClass]="{
                      'text-success':
                        attendanceclockin.workStatus === workstatusEnum.PRESENT ||
                        attendanceclockin.workStatus === 'Late',
                      'text-warning': attendanceclockin.workStatus === workstatusEnum.BREAK,
                      'text-info':
                        attendanceclockin.workStatus !== workstatusEnum.PRESENT &&
                        attendanceclockin.workStatus !== 'Late' &&
                        attendanceclockin.workStatus !== workstatusEnum.BREAK
                    }"
                  >
                  </i> -->
                  <i
                    class="ti ti-point-filled fs-20"
                    [ngStyle]="{
                      color: getStatusColor(attendanceclockin.workStatus)
                    }"
                  ></i>
                </span>
              </div>
              <div class="flex-fill ps-3 pb-4 timeline-flow">
                <div class="bg-light p-2 rounded">
                  <p class="fw-medium text-gray-9 mb-1">
                    <!-- {{
                      attendanceclockin.workStatus === workstatusEnum.PRESENT ||
                      attendanceclockin.workStatus === workstatusEnum.CLOCKIN ||
                      attendanceclockin.workStatus === workstatusEnum.LATE
                        ? workstatusEnum.CLOCKIN
                        : attendanceclockin.workStatus === workstatusEnum.BREAK
                          ? workstatusEnum.BREAK
                          : attendanceclockin.workStatus === workstatusEnum.LEAVE ||
                              attendanceclockin.workStatus === workstatusEnum.LEAVEFIRSTHALF ||
                              attendanceclockin.workStatus === workstatusEnum.LEAVESECONDHALF
                            ? attendanceclockin.workStatus
                            : attendanceclockin.workStatus === workstatusEnum.ABSENT ||
                                attendanceclockin.workStatus === workstatusEnum.ABSENTFIRSTHALF ||
                                attendanceclockin.workStatus === workstatusEnum.ABSENTSECONDHALF ||
                                attendanceclockin.workStatus === workstatusEnum.ABSENTHALF
                              ? attendanceclockin.workStatus
                              : attendanceclockin.workStatus === workstatusEnum.PRESENTHALF
                                ? workstatusEnum.PRESENTHALF
                                : attendanceclockin.workStatus === workstatusEnum.ABSENTHALF
                                  ? workstatusEnum.ABSENTHALF
                                  : attendanceclockin.workStatus === workstatusEnum.PRESENT
                                    ? workstatusEnum.PRESENT
                                    : 'N/A'
                    }} -->
                    {{
                      hiddenStatuses.has(attendanceclockin.workStatus)
                        ? ''
                        : attendanceclockin.workStatus === workstatusEnum.PRESENT ||
                            attendanceclockin.workStatus === workstatusEnum.CLOCKIN ||
                            attendanceclockin.workStatus === workstatusEnum.LATE
                          ? workstatusEnum.CLOCKIN
                          : attendanceclockin.workStatus
                    }}
                  </p>
                  <div>Time: {{ attendanceclockin.workHour }}</div>
                  <span
                    >{{
                      attendanceclockin.workStatus === workstatusEnum.PRESENT ||
                      attendanceclockin.workStatus === workstatusEnum.CLOCKIN ||
                      attendanceclockin.workStatus === 'Late'
                        ? 'Clock Out:'
                        : attendanceclockin.workStatus === workstatusEnum.BREAK
                          ? 'Break End:'
                          : 'End:'
                    }}
                    {{
                      attendanceclockin.clockOut
                        ? (attendanceclockin.clockOut | date: 'h:mm a')
                        : 'N/A'
                    }}</span
                  >
                </div>
              </div>
            </div>
            <!-- <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:20 AM</span>
              <span><i class="ti ti-point-filled text-secondary fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Design Review Hospital, doctors Management Project</p>
                <span>Review</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:18 AM</span>
              <span><i class="ti ti-point-filled text-warning fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Birthday Celebration of Employee</p>
                <span>Celebration</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:10 AM</span>
              <span><i class="ti ti-point-filled text-success fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Update of Project Flow</p>
                <span>Development</span>
              </div>
            </div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- end offcanvas-body-->
  </div>
  <!-- end offcanvas-->

  <!-- <ng-template #loading>
  <app-loader></app-loader>
</ng-template> -->
</div>
